import "./Funding.module.css";
import MainSiteHeader from "@/reusable_sections/Header";
import BuildingASaferSpace from "./sections/BuildingASaferSpace";
import TheSecurityBenchmark from "./sections/TheSecurityBenchmark";
import TechSupportInquiry from "./sections/TechSupportInquiry";
import Footer from "@/reusable_sections/Footer";
export default function FundingPage() {
  return <div>
      <MainSiteHeader />
      <BuildingASaferSpace />
      <TheSecurityBenchmark />
      <TechSupportInquiry />
      <Footer />
    </div>;
}